import React, { Suspense, lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import AppShell from '@/layout/AppShell';
import RequireAuth from '@/auth/RequireAuth';
import CallbackPage from '@/auth/CallbackPage';

// Each page is its own chunk, loaded when its route is first visited: the
// jobs pages do not carry the editor (its components, edl-core, the rule
// presets) and the Compare page carries neither. Vite shares what two
// pages both import in a common chunk; dash.js is a further chunk the
// Compare page pulls only when a package plays.
const JobsPage = lazy(() => import('@/pages/JobsPage'));
const NewJobPage = lazy(() => import('@/pages/NewJobPage'));
const JobDetailPage = lazy(() => import('@/pages/JobDetailPage'));
const JobEditorRoute = lazy(() => import('@/pages/JobEditorRoute'));
const StandaloneEditorRoute = lazy(() => import('@/pages/StandaloneEditorRoute'));
const ComparePage = lazy(() => import('@/pages/ComparePage'));

const page = (element: React.ReactNode) => (
  <Suspense fallback={<p className="muted page-loading">Loading…</p>}>{element}</Suspense>
);

export const router = createBrowserRouter([
  {
    path: '/callback',
    element: <CallbackPage />,
  },
  {
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { path: '/', element: page(<JobsPage />) },
      { path: '/jobs', element: page(<JobsPage />) },
      { path: '/jobs/new', element: page(<NewJobPage />) },
      { path: '/jobs/:jobId', element: page(<JobDetailPage />) },
      { path: '/jobs/:jobId/editor', element: page(<JobEditorRoute />) },
      { path: '/editor', element: page(<StandaloneEditorRoute />) },
      { path: '/compare', element: page(<ComparePage />) },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
